import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from './components/ContactForm';
import usePageMeta from '@/hooks/usePageMeta';

const contentScope = [
  { icon: 'ri-play-list-2-line', title: '剧集内容', desc: '收录《女友的妈妈》全 12 集的分集剧情、看点与演职人员信息。' },
  { icon: 'ri-user-star-line', title: '演员资料', desc: '整理主演出演角色、个人简介与相关作品，方便快速了解演员阵容。' },
  { icon: 'ri-newspaper-line', title: '影视资讯', desc: '汇总剧集动态、主创访谈、幕后揭秘与行业观察等资讯内容。' },
  { icon: 'ri-bookmark-3-line', title: '主题专题', desc: '围绕剧情名场面与人物线索，提供便于回顾的推荐专题合集。' },
];

export default function About() {
  usePageMeta({
    title: '关于我们 - 女友的妈妈',
    description:
      '了解《女友的妈妈》专题站的定位与内容范围，包括网站介绍、联系方式、版权声明与免责说明。',
    keywords: '女友的妈妈专题站,关于我们,网站介绍,免责声明',
  });

  return (
    <>
      <section className="w-full bg-background-100 border-b border-background-200">
        <div className="max-w-[1080px] mx-auto px-4 md:px-8 py-8 md:py-10">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-4">
            关于我们
          </h1>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl">
            「女友的妈妈」是一个专注于电视剧《女友的妈妈》内容的影视专题站，
            致力于为观众提供清晰、易读的剧情与演员信息。
          </p>
        </div>
      </section>

      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <div className="max-w-[1080px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2 space-y-10">
            <section>
              <h2 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950 mb-4">
                <i className="ri-movie-2-line text-primary-600"></i>
                网站定位
              </h2>
              <div className="space-y-4 text-sm md:text-base leading-loose text-foreground-700">
                <p>
                  「女友的妈妈」专题站以电视剧《女友的妈妈》为核心，面向喜爱该剧的观众、追剧用户以及想了解
                  剧情与演员信息的影视爱好者。我们把零散的分集信息、演员资料与相关资讯整理成清晰的门户结构，
                  让你在一处就能完成从「了解剧情」到「认识演员」再到「追踪动态」的完整浏览。
                </p>
                <p>
                  本站注重阅读体验：剧集列表支持排序与分页，演员页支持按名字检索，资讯按发布时间整理。
                  所有页面均适配手机与桌面，方便在不同设备上随时查阅。
                </p>
              </div>
            </section>

            <section>
              <h2 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950 mb-4">
                <i className="ri-stack-line text-primary-600"></i>
                内容范围
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {contentScope.map((item) => (
                  <div
                    key={item.title}
                    className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                  >
                    <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center mb-3">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-1.5">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="space-y-5">
              <h2 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950">
                <i className="ri-copyright-line text-primary-600"></i>
                版权与免责声明
              </h2>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5 space-y-3 text-xs md:text-sm leading-relaxed text-foreground-600">
                <p>
                  <strong className="text-foreground-800">版权声明：</strong>
                  本站为《女友的妈妈》剧集内容专题演示站点，页面中的剧情、演员、资讯及相关图片均为
                  演示用示例内容，仅用于展示网站结构与阅读体验，不代表任何真实影视作品或正式平台。
                </p>
                <p>
                  <strong className="text-foreground-800">免责声明：</strong>
                  本站不提供任何视频播放、下载及付费观看服务，页面中的相关表述仅为内容描述。
                  如相关权利人对本站内容有异议，欢迎通过下方联系方式与我们取得联系。
                </p>
              </div>
            </section>
          </div>

          <aside className="space-y-6">
            <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <h2 className="flex items-center gap-2 text-base md:text-lg font-bold text-foreground-950 mb-4">
                <i className="ri-mail-send-line text-accent-500"></i>
                联系方式
              </h2>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                  <div>
                    <p className="text-xs text-foreground-500">合作与反馈邮箱</p>
                    <p className="text-foreground-900 mt-0.5 break-all">contact@nvyoumama-demo.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-time-line text-primary-500 mt-0.5"></i>
                  <div>
                    <p className="text-xs text-foreground-500">回复时间</p>
                    <p className="text-foreground-900 mt-0.5">工作日 10:00 - 18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                  <div>
                    <p className="text-xs text-foreground-500">内容归属</p>
                    <p className="text-foreground-900 mt-0.5">「女友的妈妈」影视专题站</p>
                  </div>
                </div>
              </div>

              <div className="mt-5 pt-5 border-t border-background-200">
                <h3 className="text-sm font-semibold text-foreground-950 mb-3">给我们留言</h3>
                <ContactForm />
              </div>
            </section>
          </aside>
        </div>
      </div>
    </>
  );
}